import React, {Component} from "react"
import {connect} from "react-redux"
import {Link} from 'react-router'
import EnterpriseAccountTable from './components/EnterpriseAccountTable'
import IBoxRow from '../../components/IBoxRow'
import PageHeader from '../../components/PageHeader'
import PageBody from '../../components/PageBody'

import {queryEnterpriseAccounts} from '../../dispatch'
import {Breadcrumb} from "react-bootstrap"
import Alert from "../../components/Alert"
import Spinner from "../../components/Spinner"
import EnterpriseAccountWithLicenseForm from "./components/EnterpriseAccountWithLicenseForm"
import AdminPage from "./components/AdminPage"

function mapStateToProps(state, ownProps) {

  const user = state.user
  const enterpriseAccounts = state.enterpriseAccounts
  return {
    user,
    enterpriseAccounts
  }
}

const mapDispatchToProps = {
  queryEnterpriseAccounts
}


class EnterpriseAccountView extends Component {

  constructor(data){
    super(data)

    this.state = {
      id: data.params.id?data.params.id.split(',').map(id=>parseInt(id)):undefined
    }
  }

  componentWillMount() {
    this.props.queryEnterpriseAccounts(this.state.id?this.state.id.join(','):undefined)
  }

  render() {

    const breadcrumb = [
      {label: 'Home', url: '/admin'},
      {label: 'Enterprise Accounts', active: true},
    ]

    const {loading, error, data} = this.props.enterpriseAccounts

    const enterpriseAccounts = {
      loading, error,
      data: data.filter(a=>this.state.id?_.includes(this.state.id,a.id):true)
    }

    return (

      <AdminPage
        breadcrumb={breadcrumb}
        title={`Enterprise Accounts ${this.state.id ?`[${this.state.id.join(',')}]`:''}`}
        topRightComponent={(
          <Link to="/admin/createEnterpriseAccount" className="btn btn-primary">
            <i className="fa fa-plus-square"></i>
            Create Enterprise Account
          </Link>
        )}
      >
        <EnterpriseAccountTable data={enterpriseAccounts}/>
      </AdminPage>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseAccountView)



// WEBPACK FOOTER //
// ./src/routes/admin/EnterpriseAccountView.js